import { SettingOutlined } from '@ant-design/icons'
import { useSuspenseQuery } from '@apollo/client'
import { FetchMeDocument } from '@salescore/client-api'
import { Collapse, Space } from 'antd'
import type { ReactNode } from 'react'

import { canViewAdminCollapse } from '../../misc/adminPermission'
import { getOrganizationIdFromPath } from '../../presentation/common/auth'
import { HandleQuery } from '../../presentation/common/handleQuery'

export const AdminCollapse = ({ children }: { children: ReactNode }): ReactNode => {
  const organizationId = getOrganizationIdFromPath()
  const {
    data: { myUser },
  } = useSuspenseQuery(FetchMeDocument, {
    variables: { organizationId },
    fetchPolicy: 'cache-first',
  })
  const { identity: myIdentity, organization } = myUser
  const me = {
    myUser,
    myIdentity,
    organization,
  }
  if (!canViewAdminCollapse(me)) {
    return <></>
  }
  return (
    <HandleQuery>
      <Collapse defaultActiveKey={[]} className="mt-4">
        <Collapse.Panel
          header={
            <Space>
              <SettingOutlined /> <span>管理者用</span>
            </Space>
          }
          key="admin"
        >
          {children}
        </Collapse.Panel>
      </Collapse>
    </HandleQuery>
  )
}
